import React from 'react';
import { DialogProps } from '../type';
import Modal from '../../Modal';
import Button from '../../Button';
import { HelpOutlineIcon } from '../../icons';

function DangerDialog({
  id,
  title,
  content,
  onCancel,
  onOk,
  okLabel,
  cancelLabel,
  withoutIcon,
}: DialogProps) {
  return (
    <Modal
      id={id}
      {...(withoutIcon ? {} : { icon: <HelpOutlineIcon /> })}
      type="dialog"
      isOpened={true}
      closeModal={onCancel}
      title={title}
      primaryButton={
        <Button type="danger" isBlock={true} onClick={onOk}>
          {okLabel}
        </Button>
      }
      closeLabel={cancelLabel}
    >
      {content}
    </Modal>
  );
}

DangerDialog.defaultProps = {
  okLabel: 'Ok',
  cancelLabel: 'Cancel',
};

export default DangerDialog;
